/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Dialog_Edit_Tags_ForInputs */

const en_dialog_edit_tags_for = /** @type {(inputs: Dialog_Edit_Tags_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Edit tags for audio ${i?.title}`)
};

const es_dialog_edit_tags_for = /** @type {(inputs: Dialog_Edit_Tags_ForInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Editar etiquetas del audio ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Edit tags for audio {title}" |
*
* @param {Dialog_Edit_Tags_ForInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_edit_tags_for = /** @type {((inputs: Dialog_Edit_Tags_ForInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Edit_Tags_ForInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_edit_tags_for(inputs)
	return en_dialog_edit_tags_for(inputs)
});